import '../../../Styles/StudySpaces.css';
import { Add01Icon } from 'hugeicons-react';
import { useUnifiedData } from '../../../contexts/AppDataContext';
import { Header } from '../../Header/Header';
import CreateSpaceModal from './CreateSpaceModal';
import { useSpaceContext } from '../../../contexts/AppDataContext';
import SpaceCard from './SpaceCard';
import { StudySpacesSkeleton } from '../../Layout/Skeletons';

const StudySpaces = () => {
  const { isSpacesLoading, isChatsLoading, filteredSpaces } = useUnifiedData();
  const { setIsCreatingSpace } = useSpaceContext();

  const createSpace = () => {
    setIsCreatingSpace(true);
  };

  return (
    <div style={{ width: '100%' }}>
      <Header />
      <div className="study-spaces-container">
        <div className="study-spaces-header">
          <div className="header-left">
            <h1>Spaces</h1>
          </div>
          <div className="header-actions">
            <button 
              className="create-space-btn" 
              onClick={createSpace}
            >
              <Add01Icon size={16} />
              New Space
            </button>
          </div>
        </div>

        {isSpacesLoading || isChatsLoading ? (
          <StudySpacesSkeleton />
        ) : (
          <>
            {filteredSpaces.length === 0 ? (
              <div className="empty-spaces-state">
                <div className="empty-spaces-content">
                  <h2>No Spaces Yet</h2>
                  <p>Create your first space to organize your learning materials and conversations.</p>
                </div>
              </div>
            ) : (
              <div className="study-spaces-grid">
                {filteredSpaces.map(space => (
                  <SpaceCard key={space.id} space={space} />
                ))}
              </div>
            )}
          </>
        )}

        <CreateSpaceModal />
      </div>
    </div>
  );
};

export default StudySpaces;
